import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BlockModel} from '../model/block.model';
import {QuestionInfo, QuestionModel} from '../model/question.model';
import {UserAnswerMode} from '../model/user-answer.mode';
import {CHAT_CONFIG} from "../config/api";
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class UserReturningService {
  isReturning = new BehaviorSubject(false);

  constructor() {

  }

  setUserReturning() {
    this.isReturning.next(true);
  }

  setUserIsNotReturning() {
    this.isReturning.next(false);
  }

}
